export const queryKeys = {
	products: {
		all: ['products'] as const,
		lists: () => [...queryKeys.products.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.products.lists(), { query }] as const,
		details: () => [...queryKeys.products.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.products.details(), id] as const,
		histories: () => [...queryKeys.products.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.products.histories(), id] as const
	},
	bookings: {
		all: ['bookings'] as const,
		lists: () => [...queryKeys.bookings.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.bookings.lists(), { query }] as const,
		details: () => [...queryKeys.bookings.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.bookings.details(), id] as const,
		histories: () => [...queryKeys.bookings.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.bookings.histories(), id] as const,
		calendars: () => [...queryKeys.bookings.all, 'calendar'] as const,
		calandar: (query?: string) => [...queryKeys.bookings.calendars(), { query }] as const,
		transferableTargets: () => [...queryKeys.bookings.all, 'transferableTarget'] as const,
		transferableTarget: (id: string | number) =>
			[...queryKeys.bookings.transferableTargets(), id] as const
	},
	sales: {
		all: ['sales'] as const,
		lists: () => [...queryKeys.sales.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.sales.lists(), { query }] as const,
		details: () => [...queryKeys.sales.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.sales.details(), id] as const,
		histories: () => [...queryKeys.sales.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.sales.histories(), id] as const
	},
	booths: {
		all: ['booths'] as const,
		lists: () => [...queryKeys.booths.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.booths.lists(), { query }] as const,
		details: () => [...queryKeys.booths.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.booths.details(), id] as const,
		histories: () => [...queryKeys.booths.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.booths.histories(), id] as const
	},
	boothTypes: {
		all: ['boothTypes'] as const,
		lists: () => [...queryKeys.boothTypes.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.boothTypes.lists(), { query }] as const,
		details: () => [...queryKeys.boothTypes.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.boothTypes.details(), id] as const,
		histories: () => [...queryKeys.boothTypes.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.boothTypes.histories(), id] as const
	},
	categories: {
		all: ['categories'] as const,
		lists: () => [...queryKeys.categories.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.categories.lists(), { query }] as const,
		details: () => [...queryKeys.categories.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.categories.details(), id] as const,
		histories: () => [...queryKeys.categories.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.categories.histories(), id] as const
	},
	fabrics: {
		all: ['fabrics'] as const,
		lists: () => [...queryKeys.fabrics.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.fabrics.lists(), { query }] as const,
		details: () => [...queryKeys.fabrics.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.fabrics.details(), id] as const
	},
	conditions: {
		all: ['conditions'] as const,
		lists: () => [...queryKeys.conditions.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.conditions.lists(), { query }] as const,
		details: () => [...queryKeys.conditions.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.conditions.details(), id] as const
	},
	types: {
		all: ['types'] as const,
		lists: () => [...queryKeys.types.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.types.lists(), { query }] as const,
		details: () => [...queryKeys.types.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.types.details(), id] as const
	},
	genders: {
		all: ['genders'] as const,
		lists: () => [...queryKeys.genders.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.genders.lists(), { query }] as const,
		details: () => [...queryKeys.genders.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.genders.details(), id] as const
	},
	coupons: {
		all: ['coupons'] as const,
		lists: () => [...queryKeys.coupons.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.coupons.lists(), { query }] as const,
		details: () => [...queryKeys.coupons.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.coupons.details(), id] as const,
		histories: () => [...queryKeys.coupons.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.coupons.histories(), id] as const
	},
	mapConfig: {
		all: ['mapConfig'] as const
	},
	openingHours: {
		all: ['openingHours'] as const,
		lists: () => [...queryKeys.openingHours.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.openingHours.lists(), { query }] as const,
		details: () => [...queryKeys.openingHours.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.openingHours.details(), id] as const,
		histories: () => [...queryKeys.openingHours.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.openingHours.histories(), id] as const
	},
	payouts: {
		all: ['payouts'] as const,
		lists: () => [...queryKeys.payouts.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.payouts.lists(), { query }] as const,
		details: () => [...queryKeys.payouts.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.payouts.details(), id] as const,
		histories: () => [...queryKeys.payouts.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.payouts.histories(), id] as const
	},
	rentals: {
		all: ['rentals'] as const,
		lists: () => [...queryKeys.rentals.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.rentals.lists(), { query }] as const,
		details: () => [...queryKeys.rentals.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.rentals.details(), id] as const,
		histories: () => [...queryKeys.rentals.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.rentals.histories(), id] as const
	},
	commissions: {
		all: ['commissions'] as const
	},
	languages: {
		all: ['languages'] as const
	},
	tags: {
		all: ['tags'] as const,
		lists: () => [...queryKeys.tags.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.tags.lists(), { query }] as const,
		details: () => [...queryKeys.tags.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.tags.details(), id] as const,
		histories: () => [...queryKeys.tags.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.tags.histories(), id] as const
	},
	users: {
		all: ['users'] as const,
		lists: () => [...queryKeys.users.all, 'list'] as const,
		list: (query?: string) => [...queryKeys.users.lists(), { query }] as const,
		details: () => [...queryKeys.users.all, 'detail'] as const,
		detail: (id: string | number) => [...queryKeys.users.details(), id] as const,
		histories: () => [...queryKeys.users.all, 'history'] as const,
		history: (id: string | number) => [...queryKeys.users.histories(), id] as const
	},
	dashboard: {
		all: ['dashboard'] as const
	},
	storeSettings: {
		all: ['storeSettings'] as const
	},
	widgetData: {
		all: ['widgetData'] as const
	},
	me: {
		all: ['me'] as const
	},
	storeData: {
		all: ['storeData'] as const
	},
	payoutMethods: {
		all: ['payoutMethods'] as const
	},
	countries: {
		all: ['countries'] as const
	},
	currencies: {
		all: ['currencies'] as const
	}
}
